// client/src/admin/resources/fornitori.js
import * as React from 'react';
import { List, Datagrid, TextField, NumberField, EditButton, DeleteButton,
         Edit, SimpleForm, TextInput, Create, required } from 'react-admin';

export const FornitoreList = (props) => (
  <List {...props} sort={{ field: 'nome', order: 'ASC' }}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="nome" />
      <TextField source="indirizzo" />
      <TextField source="cap" />
      <TextField source="citta" />
      <TextField source="provincia" />
      <TextField source="telefono" />
      <NumberField source="latitudine" />
      <NumberField source="longitudine" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const FornitoreEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="nome" validate={[required()]} />
      <TextInput source="indirizzo" validate={[required()]} />
      <TextInput source="cap" validate={[required()]} />
      <TextInput source="citta" validate={[required()]} />
      <TextInput source="provincia" validate={[required()]} />
      <TextInput source="telefono" />
    </SimpleForm>
  </Edit>
);

export const FornitoreCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="nome" validate={[required()]} />
      <TextInput source="indirizzo" validate={[required()]} />
      <TextInput source="cap" validate={[required()]} />
      <TextInput source="citta" validate={[required()]} />
      <TextInput source="provincia" validate={[required()]} />
      <TextInput source="telefono" />
    </SimpleForm>
  </Create>
);
